
import { z } from "zod";

// Validation schemas for each step
export const basicsSchema = z.object({
  companyName: z.string().min(1, "Company name is required"),
  teamSize: z.number().min(1, "Team size must be at least 1"),
  location: z.string().optional(),
  website: z.union([z.string().url("Must be a valid URL"), z.literal("")]).optional(),
  contactEmail: z.string().email("Must be a valid email address"),
});

export const capacitySchema = z.object({
  projectsPerMonth: z.number().min(0, "Projects per month must be 0 or greater"),
  minEngagement: z.number().min(0, "Minimum engagement must be 0 or greater"),
  availabilityStart: z.string().min(1, "Availability start month is required"),
  notes: z.string().optional(),
});

export const industriesSchema = z.object({
  selectedIndustries: z.array(z.string()),
  otherIndustry: z.string().optional(),
}).refine((data) => 
  data.selectedIndustries.length > 0 || (data.otherIndustry && data.otherIndustry.trim() !== ""),
  { message: "Select at least one industry or specify other" }
);

export const channelsSchema = z.object({
  selectedChannels: z.array(z.string()),
  otherChannel: z.string().optional(),
}).refine((data) => 
  data.selectedChannels.length > 0 || (data.otherChannel && data.otherChannel.trim() !== ""),
  { message: "Select at least one channel or specify other" }
);

export const budgetsSchema = z.object({
  selectedBudgets: z.array(z.string()).min(1, "Select at least one budget band"),
});

export const uploadsSchema = z.object({
  files: z.array(z.instanceof(File)).optional(),
});

export const linksSchema = z.object({
  portfolioLinks: z.array(z.string().url("Must be a valid URL")).optional(),
});

// Combined schema
export const proOnboardingSchema = z.object({
  basics: basicsSchema,
  capacity: capacitySchema,
  industries: industriesSchema,
  channels: channelsSchema,
  budgets: budgetsSchema,
  uploads: uploadsSchema,
  links: linksSchema,
});

export type ProOnboardingData = z.infer<typeof proOnboardingSchema>;

// Options for selects
export const INDUSTRY_OPTIONS = [
  "eCommerce",
  "SaaS",
  "Local Business",
  "B2B",
  "Travel & Hospitality",
  "Healthcare",
  "Education",
  "Finance",
];

export const CHANNEL_OPTIONS = [
  "Meta Ads",
  "Google Ads",
  "TikTok Ads",
  "LinkedIn Ads",
  "SEO",
  "Email Marketing",
  "Affiliate Marketing",
];

export const BUDGET_OPTIONS = [
  "Under €1,000/month",
  "€1,000 - €3,000/month",
  "€3,000 - €10,000/month",
  "€10,000 - €30,000/month",
  "€30,000+/month",
  "Enterprise (€100k+)",
];
